module.exports = __webpack_public_path__ + "static/media/googlePlay.70845a50.svg";